import { h } from 'preact'; /** @jsx h */
import { useRef } from 'preact/hooks';

import './ExtraContribution.scss';

const ExtraContribution = ({
    setContributionValue,
    viewContributionInput,
    setViewContributionInput,
    handleKeyPress,
    isReciept = false
}) => {
    const inputRef = useRef();

    return (
        <div className="ws-products-contribute">
            <h4 className="ws-contribute-title">Legg til et valgfritt tilleggsbeløp</h4>
            <p className="ws-contribute-text">
                Legg til et valgfritt tilleggsbeløp i handlevognen som går direkte til Stiftelsen
                Norsk Luftambulanse.
            </p>
            <div className="ws-contribution-products">
                <button
                    className="ws-contribution-btn"
                    value="100"
                    onClick={e => setContributionValue(parseInt(e.target.value))}
                >
                    100 kr.
                </button>
                <button
                    className="ws-contribution-btn"
                    value="200"
                    onClick={e => setContributionValue(parseInt(e.target.value))}
                >
                    200 kr.
                </button>
                <button
                    className="ws-contribution-btn"
                    value="300"
                    onClick={e => setContributionValue(parseInt(e.target.value))}
                >
                    300 kr.
                </button>
                <button
                    className="ws-contribution-btn"
                    onClick={() => setViewContributionInput(!viewContributionInput)}
                >
                    Annet beløp
                </button>
            </div>
            {viewContributionInput && (
                <div className="ws-contribution-amount">
                    <input
                        ref={inputRef}
                        className="ws-contribution-input"
                        type="text"
                        placeholder="Skriv inn ønsket beløp"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        onKeyPress={handleKeyPress}
                    />
                    <button
                        className="ws-contribution-btn"
                        type="submit"
                        onClick={() => {
                            setContributionValue(inputRef.current.value);
                            setViewContributionInput(false);
                        }}
                    >
                        Legg til bidrag {isReciept && 'i handlevogn'}
                    </button>
                </div>
            )}
        </div>
    );
};

export default ExtraContribution;
